export const ACTIVE_WALLET_COOKIE_KEY = '_activeWallet';
